import React, { useRef, useEffect, useCallback } from "react"
import { Link } from "gatsby"
import { useSpring, animated } from "react-spring"
import { useForm, ValidationError } from '@formspree/react';

import styles from "./modal.module.css"

import closeButton from "../../images/close_button.svg"

const Modal = ({ showModal, setShowModal }) => {
  const modalRef = useRef()
  const closeRef = useRef()

  const [state, handleSubmit] = useForm("mknpkyrj");

  const animation = useSpring({
    config: {
      duration: 250,
    },
    opacity: showModal ? 1 : 0,
    transform: showModal ? `translateY(0%)` : `translateY(-100%)`,
  })

  const closeModal = e => {
    if (modalRef.current === e.target || closeRef.current === e.target) {
      setShowModal(false)
    }
  }

  const keyPress = useCallback(
    e => {
      if (e.key === "Escape" && showModal) {
        setShowModal(false)
        console.log("I pressed")
      }
    },
    [setShowModal, showModal]
  )

  useEffect(() => {
    document.addEventListener("keydown", keyPress)
    return () => document.removeEventListener("keydown", keyPress)
  }, [keyPress])

  return (
    <>
      {showModal ? (
        <div className={styles.Background} onClick={closeModal} ref={modalRef}>
          <div className={styles.Animated}>
            <div className={styles.ModalWrapper}>
              <div className={styles.ModalContent}>
                <h1>Interested in the Beta?</h1>
                <p>Get early access to our beta launch.</p>
                {state.succeeded ? (<div><p>Thanks for signing up!  We'll be in touch shortly.</p></div>) :
                <form
                  onSubmit={handleSubmit}
                  // action={url}
                  // method="POST"
                  className={styles.Form}
                >
                  <div className={styles.NameWrapper}>
                  <input
                    type="text"
                    name="name"
                    className={styles.Name}
                    placeholder="Name"
                    required
                    maxLength="30"
                  />
                  <ValidationError 
                    prefix="Name" 
                    field="name"
                    errors={state.errors}
                  />
                </div>
                <div className={styles.EmailWrapper}>
                  <input
                    type="email"
                    name="email"
                    id="email"
                    placeholder="Email"
                    className={styles.Email}
                    required
                    maxLength="50"
                  />
                   <ValidationError 
                      prefix="Email" 
                      field="email"
                      errors={state.errors}
                    />
                </div>
                <button type="submit" disabled={state.submitting} className={styles.Button}>
                  Join Now
                </button>
                </form>
                }
                {/* <Link
                  to="/#about"
                  className={styles.Button}
                  // onClick={handleOpenModal}
                >
                  Join Now
                </Link> */}
              </div>
              <div className={styles.CloseModalButton}>    
                <img src={closeButton} ref={closeRef} />
              </div>
            </div>
          </div>
        </div>
      ) : // <animated.div style={animation}>
      //   <ModalWrapper showModal={showModal}>
      //     <ModalImg src={require("./modal.jpg")} alt="camera" />
      //     <ModalContent>
      //       <h1>Are you ready?</h1>
      //       <p>Get exclusive access to our next launch.</p>
      //       <button>Join Now</button>
      //     </ModalContent>
      //     <CloseModalButton
      //       aria-label="Close modal"
      //       onClick={() => setShowModal(prev => !prev)}
      //     />
      //   </ModalWrapper>
      // </animated.div>
      null}
    </>
  )
}

export default Modal
